export default __webpack_public_path__ + "static/media/Maharaja01.3e66ffcf.jpg";